import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-header__sortable-content"
}
const _hoisted_2 = { class: "table-header__text" }
const _hoisted_3 = {
  key: 1,
  class: "table-header__text"
}

import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { ForecastForReceiptTableContentViewModel } from './forecastForReceiptTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';
import { computed } from 'vue';
// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastForReceiptTableHead',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    forecastStartYearMonth: { default: undefined }
  },
  emits: ["onClickSort", "onMousedownResizer"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const forecastForReceiptTableContentVM = new ForecastForReceiptTableContentViewModel();
// emits
const emits = __emit;
//変数
const t = i18n.t;

const headerText = computed(() => {
  if (props.header.displayLabel) {
    return t(props.header.displayLabel);
  }
  return t(forecastForReceiptTableContentVM.getHeaderText(props.header.key, props.forecastStartYearMonth));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableHead, {
    class: _normalizeClass([_unref(forecastForReceiptTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : '']),
    style: _normalizeStyle({
      left: _unref(forecastForReceiptTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    index: _ctx.headerIndex,
    "text-align": 
      _ctx.header.key === 'ForecastForReceiptRecoverStatus' && !_ctx.header.displayLabel
        ? 'center'
        : _ctx.header.key === 'ForecastForReceiptRowMenu' || _ctx.header.key === 'ForecastForReceiptEditOption'
        ? 'right'
        : 'left'
    ,
    resizable: 
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      _ctx.header.isVariableWidth && !_unref(forecastForReceiptTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex)
    ,
    onOnMousedownResizer: _cache[1] || (_cache[1] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
  }, {
    default: _withCtx(() => [
      (_ctx.header.sortOption.isSortable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(headerText.value), 1),
            _createVNode(ArrowIcon, {
              asc: _ctx.header.sortOption.isAsc,
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc)))
            }, null, 8, ["asc"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(headerText.value), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "index", "text-align", "resizable"]))
}
}

})